import {
  Directive,
  inject,
  Input,
  signal,
  ChangeDetectorRef
} from '@angular/core';
import { AbstractButtonInterface } from '@jeppesen-foreflight/jmkw-types';
import { ToolkitApiService } from '../../api';

@Directive()
export abstract class AbstractButton implements AbstractButtonInterface {
  @Input() id!: string;

  toolkitApiService = inject(ToolkitApiService);
  private readonly _cdr = inject(ChangeDetectorRef, { optional: true });

  $active = signal(false);
  $hover = signal(false);
  $disabled = signal(false);

  @Input()
  set active(value: boolean) {
    this.$active.set(value);
    this._cdr?.markForCheck();
  }
  get active(): boolean {
    return this.$active();
  }

  @Input()
  set hover(value: boolean) {
    this.$hover.set(value);
    this._cdr?.markForCheck();
  }
  get hover(): boolean {
    return this.$hover();
  }

  @Input()
  set disabled(value: boolean) {
    this.$disabled.set(value);
    this._cdr?.markForCheck();
  }
  get disabled(): boolean {
    return this.$disabled();
  }

  /**
   * Toggle/set active state
   */
  toggleActive(active?: boolean): void {
    if (active !== undefined) {
      this.active = active;
    } else {
      this.active = !this.active;
    }
  }

  /**
   * Toggle/set enabled state
   * @param enabled - true to enable (disabled = false), false to disable (disabled = true)
   */
  toggleEnabled(enabled?: boolean): void {
    if (enabled !== undefined) {
      this.disabled = !enabled;
    } else {
      this.disabled = !this.disabled;
    }
  }

  /**
   * Toggle/set hover state
   */
  toggleHover(hover?: boolean): void {
    if (hover !== undefined) {
      this.hover = hover;
    } else {
      this.hover = !this.hover;
    }
  }
}
